import { QueryClient, QueryClientProvider } from "react-query";
import { config } from "../../utils/conf";
import Loader from "react-loader-spinner";
import useGetImage from "../../hooks/useGetImage";
import store from "../../store";
import { Provider } from "react-redux";

const ImageContent = (props) => {
  const { mediaUrl, options, itemId } = props;

  const filteredItem =
    !mediaUrl && options?.find((opt) => opt.rawData?.itemId === itemId);
  const resolvedMediaUrl =
    filteredItem?.rawData?.mediaUrl ?? filteredItem?.mediaUrl;
  const imageUrl =
    mediaUrl ??
    resolvedMediaUrl ??
    (itemId
      ? `${config.rpcImagePath}${itemId}.png`
      : `${config.rpcImagePath}default.png`);

  const imageQuery = useGetImage(imageUrl, `${config.rpcImagePath}default.png`);

  return (
    <div className="tw-relative tw-w-full tw-min-h-[210px]">
      {!imageQuery.isFetching && (
        <img
          className="tw-object-contain tw-w-full tw-block"
          style={{ height: "90%" }}
          src={imageQuery.data}
          alt={itemId}
        />
      )}

      {imageQuery.isFetching && (
        <div className="tw-absolute tw-inset-0 tw-flex tw-items-center tw-justify-center">
          <Loader
            type="ThreeDots"
            color="rgba(246,130,32,1)"
            height="50"
            width="50"
          />
        </div>
      )}
    </div>
  );
};

const Wrapper = (props) => {
  const queryClient = new QueryClient();
  return (
    <Provider store={store}>
      <QueryClientProvider client={queryClient}>
        <ImageContent {...props} />
      </QueryClientProvider>
    </Provider>
  );
};

export default Wrapper;
